import { render, staticRenderFns } from "./seniority.vue?vue&type=template&id=03c27fb8&scoped=true&"
import script from "./seniority.vue?vue&type=script&lang=js&"
export * from "./seniority.vue?vue&type=script&lang=js&"
import style0 from "./seniority.vue?vue&type=style&index=0&id=03c27fb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c27fb8",
  null
  
)

export default component.exports